function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.45 68.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M74.49,45.02v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M74.49,53.77v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M74.49,27.51v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M74.49,27.51c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25,5.49-5.25,12.26-5.25,12.26,2.35,12.26,5.25ZM74.49,36.26v8.76c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.76M49.98,45.02v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M49.98,45.02c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25,5.49-5.25,12.26-5.25,12.26,2.35,12.26,5.25ZM49.98,53.77v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M25.47,53.77v8.75c0,2.9-5.49,5.25-12.26,5.25s-12.26-2.35-12.26-5.25v-8.75M25.47,53.77c0,2.9-5.49,5.25-12.26,5.25S.95,56.68.95,53.77s5.49-5.25,12.26-5.25,12.26,2.35,12.26,5.25Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.85,10.66l-3.87-9.7M4.16,38.02C25.47,34.51,46.15,20.5,49.98.95l-8.86,6.04",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico06);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-06.7804cc7f2bcfa9f37a2c2e98a86363a1.svg";
export { ForwardRef as ReactComponent };